import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface DeleteContainerData {
  containerUuid: string;
}

interface DeleteContainerResponse {
  data: any;
}

export function useDeleteContainer() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      deleteData: DeleteContainerData
    ): Promise<DeleteContainerResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/delete_container`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(deleteData),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userContainers']
      });
    },
  });
}
